import apiClient from '../apiClient';
import { GET_TOUR_TRANSACTION_BILLS_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getTourTransactioBillsApi = Id => {
  return apiClient.get(GET_TOUR_TRANSACTION_BILLS_BY_TRANSACTION_ID_URL(Id));
};

export default getTourTransactioBillsApi;
